module.exports = __webpack_public_path__ + "static/media/OUR MISSION.db23850d.png";